// ---------------------------------------------------------------------------
// Central application config – single source of truth.
//
// Birdsnest only ships the Fredhopper provider (with the Style Matches Peacock
// middleware sitting in front of it for `data-collection-id="style-matches"`).
// Values are read straight from environment variables — no demo Control Panel
// / localStorage / encryption machinery.
// ---------------------------------------------------------------------------
const fredhopperConfig = {
    apiUrl: process.env.FREDHOPPER_API_URL || '',
    siteId: process.env.FREDHOPPER_SITE_ID || '',
    locale: process.env.FREDHOPPER_LOCALE || 'en_GB',
    displayFieldsMode: process.env.FREDHOPPER_DISPLAY_FIELDS_MODE || 'live',
};
export const isDevelopment = process.env.NODE_ENV === 'development';
export const isProduction = process.env.NODE_ENV === 'production';
export const AppConfig = {
    /** Which search backend to use. Always `'fredhopper'` for this app. */
    provider: 'fredhopper',
    /** How UI state is pushed to the URL */
    routing: 'query-param',
    /** Default storefront query when the page first loads */
    defaultQuery: '*',
    /** Pagination defaults */
    page: {
        defaultSize: 24,
        maxSize: 48,
    },
    /** Per-provider secrets / endpoints – only Fredhopper */
    searchSettings: {
        fredhopper: fredhopperConfig,
    },
};
export default AppConfig;
